import { useTranslation } from 'react-i18next';
import SpinLoader from "../components/spin-loader";
import { hideOverlay } from "../utils/utils";

import MoodboardComponent from '../components/moodboard/moodboard-comp';

const SingleMoodboard = () => {
    const { t, i18n } = useTranslation();

    return (
        <div className="moodboard-page">
            <h1 className="page-h1">{i18n.exists("pages.moodBoard") ? t('pages.moodBoard') : "MoodBoard"}</h1>
            <MoodboardComponent />
        </div>
    )
}

export default SingleMoodboard;